import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4307cfd3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-profile-wrapper" }
const _hoisted_2 = { class: "group" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = { class: "box-list-group" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "group" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  class: "text-center",
  style: {"margin-top":"4.5rem"}
}

import { computed } from 'vue';
  import { authStore } from '@/stores';
  import { useI18n } from 'vue-i18n';
  import { GENDER_MAP } from '@/constants';
  import { getOAuthProviderByLocale } from '@/utils';
  import _ from 'lodash';
  import MemberRecent from './components/member-recent.vue';

  type InfoData = {
    label: string;
    value: string;
    key: string;
  }

  type DefaultGroup = {
    title: string;
    listGroup?: Array<InfoData[]>
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t, locale } = useI18n();
  const group = computed<DefaultGroup[]>(() => {
    const defaultGroup: DefaultGroup[] = [
      {
        title: t('Contact information'),
        listGroup: [
          [
            { label: t('Last name'), value: '', key: 'last_name' },
            { label: t('First name'), value: '', key: 'first_name' },
            { label: t('Nickname'), value: '', key: 'nick_name' },
            { label: t('Email address'), value: '', key: 'email' },
            { label: t('Phone number'), value: '', key: 'phone_number' },
          ],
          [
            { label: t('Zip code'), value: '', key: 'postal_code' },
            { label: t('State'), value: '', key: 'region' },
            { label: t('City'), value: '', key: 'locality' },
            { label: t('Street Address'), value: '', key: 'street_address' },
            { label: t('Extended Address'), value: '', key: 'extended_address' },
          ]
        ]
      },
      {
        title: '', // DELETE (not needed)
        listGroup: [
          [
            { label: t('Age'), value: '', key: 'age' },
            { label: t('Gender'), value: '', key: 'gender' },
            { label: t('People collecting'), value: '', key: 'people_collection' }
          ],
          [
            { label: t('Organization name'), value: '', key: 'organization_name' },
            { label: t('Organization type'), value: '', key: 'organization_type' },
            // 只有韩国显示
            locale.value === 'ko' && { label: t('마케팅 정보 수신 동의'), value: '', key: 'subscribe_tc_information' },
          ].filter(Boolean) as InfoData[]
        ]
      }
    ];
    const profile: { [key: string]: any } = authStore.user?.profile || {};
    defaultGroup.forEach(item => {
      _.flatten(item.listGroup).forEach(data => {
        data.value = profile[data.key] || '/';
        if (data.key === 'gender') {
          data.value = GENDER_MAP[data.value] || '/';
        }
        if (data.key === 'phone_number') {
          data.value = authStore.phoneNumber || '/';
        }
        if (data.key === 'subscribe_tc_information') {
          data.value = authStore.user?.subscribe_tc_information ? '동의' : '거부';
        }
      });
    });
    return defaultGroup;
  });

  const connectList = computed(() => {
    const providers = authStore.user?.oauth_identities_providers || [];
    const list = getOAuthProviderByLocale(locale.value);
    providers.map((provider: string) => {
      const item = list.find(({ name }) => name === provider);
      if (item) {
        item.connect = true;
        item.click = () => {};
      }
    });
    return list;
  });

  authStore.tryFetchData();

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(group), (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (item.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.title), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.listGroup, (list, listKey) => {
              return (_openBlock(), _createElementBlock("div", {
                key: listKey,
                class: "list"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (content, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "item"
                  }, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(content.label), 1),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(content.value), 1)
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('Connect your account')), 1),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(connectList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["connect-item pointer", { connected: item.connect }]),
            onClick: ($event: any) => (item.click())
          }, [
            _createElementVNode("img", {
              src: item.url,
              class: "icon"
            }, null, 8, _hoisted_11),
            _createElementVNode("span", null, _toDisplayString(item.connect ? _unref(t)('Connected') : _unref(t)('Connect')), 1)
          ], 10, _hoisted_10))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_b_button, {
        pill: "",
        variant: "primary",
        size: "lg",
        style: {"width":"20rem"},
        to: { name: 'mine.memberProfile.edit' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('Edit Your Profile')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(MemberRecent, {
      style: {"margin-top":"7rem"},
      role: _unref(authStore).user.company_account?.role
    }, null, 8, ["role"])
  ]))
}
}

})